// extracted by mini-css-extract-plugin
export default {"verified_part":"buttons_verified_part__CJF9y","verified":"buttons_verified__iYAbM","restart_part":"buttons_restart_part__xEgvL","restart":"buttons_restart__HvRju"};